import Sidebar from "../../DesignSystem/Sidebar";
import "../../../css/Compliance/Chatbot/ChatbotScreen.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  faCircleCheck,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonYellow from "../../DesignSystem/Buttons/ButtonYellow";
import { Close } from "@mui/icons-material";
import SignInButton from "../../DesignSystem/Buttons/SignInButton";
import { useUserPermissions } from "../../SignIn/UserPermissionsContext";
import { Helmet } from "react-helmet-async";
import { useUserEmail } from "../../SignIn/UserEmailContext";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";

const ChatbotScreen = () => {
  const [messages, setMessages] = useState([
  ]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);
  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const [currentRejectMsg, setCurrentRejectMsg] = useState(null);
  const [suggestedAnswer, setSuggestedAnswer] = useState("");
  const { userPermissions } = useUserPermissions();
  const COMPLIANCE_CHATBOT_URL = process.env.REACT_APP_COMPLIANCE_CHATBOT_URL;
  const { userEmail } = useUserEmail();



  // useEffect(() => {
  //   console.log("User Email:", userEmail);
  // }, [userEmail]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const [typing, setTyping] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    setInput(""); // Clear input immediately
    setTyping(true); // Show typing animation
    // console.log(userEmail);

    try {
      const res = await fetch(`${COMPLIANCE_CHATBOT_URL}/api/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: input,
          requestedBy: userEmail || localStorage.getItem("userEmail"),
        }),
      });

      const data = await res.json();


      // Simulate delay for typing effect (optional)
      setTimeout(() => {
        const botMessage = {
          sender: "bot",
          requestedBy: userEmail || localStorage.getItem("userEmail"),
          text: data.response,
          firebasePending: !data.cached,
          question: input, // store original question for approve handler
        };
        setMessages((prev) => [...prev, botMessage]);
        setTyping(false);
      }, 1000);
    } catch (err) {
      setTyping(false);
      // console.error("Error fetching response", err);
    }
  };

  const handleApprove = async (question, answer) => {
    const messageToApprove = messages.find(
      (msg) => msg.text === answer && msg.sender === "bot"
    );

    const requestedBy = messageToApprove?.requestedBy || "unknown";

    await fetch(`${COMPLIANCE_CHATBOT_URL}/api/approve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        answer,
        requestedBy, // preserved from when user submitted the question
        approvedBy: userEmail || localStorage.getItem("userEmail"), // current admin approver
      }),
    });

    // Optional: Update UI
    setMessages((prev) =>
      prev.map((msg) =>
        msg.text === answer ? { ...msg, firebasePending: false } : msg
      )
    );
  };

  // useEffect(() => {
  //   console.log("User Email:", localStorage.getItem("userEmail"));

  // }, []);

  const handleReject = async (question, answer, suggestedAnswer) => {
    const messageToReject = messages.find(
      (msg) => msg.text === answer && msg.sender === "bot"
    );

    const requestedBy = messageToReject?.requestedBy || "unknown";

    await fetch(`${COMPLIANCE_CHATBOT_URL}/api/reject`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        answer,
        requestedBy,
        rejectedBy: userEmail || localStorage.getItem("userEmail"),
        suggestedAnswer: suggestedAnswer.trim() || "No suggestion provided",
      }),
    });

    // Optional: update UI or remove the message
    setMessages((prev) =>
      prev.map((msg) =>
        msg.text === answer
          ? { ...msg, rejected: true, firebasePending: false }
          : msg
      )
    );
  };

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (
  //     !userPermissions.includes("Administrator") &&
  //     !userPermissions.includes("Compliance")
  //   ) {
  //     console.log("User has admin permissions");
  //     navigate("/");
  //   }
  // }, [userPermissions]);

  return (
    <div className="Main-Page">
      <Helmet>
        <title>1-AIN</title>
        <meta
          name="description"
          content="Chatbot for compliance-related queries and cached responses."
        />
      </Helmet>
      <Sidebar />
      <div className="Main-Container chatbot-page-container">
        <div className="chatbot-page-header">
          <div className="chatbot-breadcrumb">
            <Breadcrumb
              items={[
                {
                  label: "Compliance",
                  to: "/Department/Compliance",
                },
                { label: "1-AIN" },
              ]}
            />
          </div>
          <div className="admin-chatbot-header">
            <SignInButton
              title={"History"}
              onClick={() => {
                navigate("/1-AINHistory");
              }}
            />
          </div>
        </div>
        <div
          className={`chatbot-layout ${messages.length === 0 ? "empty" : ""} 
          ${messages.length > 0 ? "hasMessages" : ""}`}
        >
          {messages.length === 0 && (
            <>
              <div className="chatbot-header">
                <h3>What can I help with?</h3>
              </div>
              <div className="chatbot-footer">
                <div className="Content">
                  DISCLAIMER: If you are using this tool for the first time,
                  please log out and sign in again to ensure your access
                  permissions are correctly applied.
                </div>
              </div>
            </>
          )}
          {/* {userPermissions.includes("Administrator") && (
          )} */}
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message-wrapper ${
                  msg.sender === "user" ? "user" : "bot"
                }`}
              >
                <div className={`message Input ${msg.sender}`}>{msg.text}</div>
                {msg.sender === "bot" &&
                  msg.firebasePending &&
                  !msg.rejected && (
                    <>
                      <div
                        onClick={() =>
                          handleApprove(msg.question || "", msg.text)
                        }
                      >
                        <FontAwesomeIcon
                          className="approve-button"
                          icon={faCircleCheck}
                        />
                      </div>
                      <div
                        onClick={() => {
                          setCurrentRejectMsg({
                            question: msg.question || "",
                            answer: msg.text,
                            requestedBy: msg.requestedBy || "unknown",
                          });
                          setShowSuggestionModal(true);
                        }}
                      >
                        <FontAwesomeIcon
                          className="approve-button"
                          icon={faTimesCircle}
                        />
                      </div>
                    </>
                  )}
              </div>
            ))}

            {typing && (
              <div className="message bot typing">
                <span className="typing-dots">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          <div className={`chatbot-input-container`}>
            <input
              type="text"
              placeholder="Ask anything..."
              className="chatbot-input Input"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button
              className="send-button"
              onClick={sendMessage}
              disabled={!input.trim()}
            >
              ➤
            </button>
          </div>
        </div>
      </div>
      {showSuggestionModal && (
        <div className="suggest-modal">
          <div className="modal-content">
            <div
              className="close-button"
              onClick={() => setShowSuggestionModal(false)}
            >
              <Close />
            </div>
            <div className="Title">Suggest a Better Answer</div>
            <textarea
              placeholder="Enter your suggested answer"
              value={suggestedAnswer}
              className="Input"
              onChange={(e) => setSuggestedAnswer(e.target.value)}
            />
            <ButtonYellow
              onClick={async () => {
                // const res = await fetch("http://localhost:5000/api/reject", {
                //   method: "POST",
                //   headers: { "Content-Type": "application/json" },
                //   body: JSON.stringify({
                //     question: currentRejectMsg.question,
                //     answer: currentRejectMsg.answer,
                //     requestedBy: currentRejectMsg.requestedBy,
                //     rejectedBy: localStorage.getItem("userEmail"),
                //     suggestedAnswer,
                //   }),
                // });

                handleReject(
                  currentRejectMsg.question,
                  currentRejectMsg.answer,
                  suggestedAnswer
                );

                // Update UI
                setMessages((prev) =>
                  prev.map((msg) =>
                    msg.text === currentRejectMsg.answer
                      ? { ...msg, rejected: true, firebasePending: false }
                      : msg
                  )
                );
                setSuggestedAnswer("");
                setShowSuggestionModal(false);
              }}
              buttonText={"Submit"}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotScreen;
